"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
const commonHeading = {
  fontWeight: "bold",
  fontStretch: "condensed",
  textTransform: "uppercase",
  letterSpacing: ".1px"
};
const desktopSizes = {
  body1: {
    fontSize: 18,
    lineHeight: "1.66"
  },
  h1: (0, _extends2.default)({
    fontSize: "4.77em",
    lineHeight: "1.11"
  }, commonHeading),
  h2: (0, _extends2.default)({
    fontSize: "3.33em",
    lineHeight: "1.16"
  }, commonHeading),
  h3: (0, _extends2.default)({
    fontSize: "1.77em",
    lineHeight: "1.25"
  }, commonHeading),
  h4: (0, _extends2.default)({
    fontSize: "1.33em",
    lineHeight: "1.33"
  }, commonHeading),
  h5: (0, _extends2.default)({
    fontSize: "1.16em",
    lineHeight: "1.66"
  }, commonHeading),
  h6: (0, _extends2.default)({
    fontSize: "1em",
    lineHeight: "1.66"
  }, commonHeading)
};
const typography = {
  useNextVariants: true,
  fontFamily: ['"bahnschrift"', "Arial", "sans-serif"].join(", "),
  fontSize: 16,
  body1: {
    fontSize: 16,
    lineHeight: "1.625"
  },
  h1: (0, _extends2.default)({
    fontSize: "3.125em",
    lineHeight: "1.2"
  }, commonHeading),
  h2: (0, _extends2.default)({
    fontSize: "2.5em",
    lineHeight: "1.25"
  }, commonHeading),
  h3: (0, _extends2.default)({
    fontSize: "1.5em",
    lineHeight: "1.33"
  }, commonHeading),
  h4: (0, _extends2.default)({
    fontSize: "1.125em",
    lineHeight: "1.66"
  }, commonHeading),
  h5: (0, _extends2.default)({
    fontSize: "1.065em",
    lineHeight: "1.625"
  }, commonHeading),
  h6: (0, _extends2.default)({
    fontSize: "1em",
    lineHeight: "1.625"
  }, commonHeading),
  button: {
    fontWeight: "bold",
    fontStretch: "condensed",
    textTransform: "uppercase",
    letterSpacing: "1.5px",
    lineHeight: 1
  },
  desktop: desktopSizes
};
var _default = exports.default = {
  base: typography,
  overwrites: desktopSizes
};